export default __webpack_public_path__ + "icon_security.335dea54d45fb89a3b587e3d2340b7e1.svg";